// extracted by mini-css-extract-plugin
export default {"recent_trades_content":"RecentTrades_recent_trades_content__EkNRQ","no_recent_trades":"RecentTrades_no_recent_trades__vgvS5"};